import i18n from "../i18n/i18n";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*_\-+={[}\]|\\:;"'<,>.?/]).{5,}$/;

export function validateRegisterInput(username, email, password) {
  if (!username && !email && !password) {
    return i18n.t("errors.pleaseEnterUsernameEmailAndPassword", "Please enter username, email and password.");
  }
  if (!username) {
    return i18n.t("errors.pleaseEnterFullName", "Please enter your full name.");
  }
  if (!email) {
    return i18n.t("errors.pleaseEnterEmail", "Please enter your email address.");
  }
  if (!emailRegex.test(email)) {
    return i18n.t("errors.pleaseEnterValidEmail", "Please enter a valid email address.");
  }
  if (!password) {
    return i18n.t("errors.pleaseEnterPassword", "Please enter your password.");
  }
  if (!passwordRegex.test(password)) {
    return i18n.t(
      "errors.passwordStrength",
      "Password must be at least 5 characters long and include at least one uppercase letter, one number, and one special symbol."
    );
  }
  return null;
}

export function parseRegisterError(error) {
  const status = error?.status ?? error?.response?.status;
  const detail = error?.response?.data?.detail;

  if (typeof detail === "string") {
    if (detail.toLowerCase().includes("already exists") || detail.toLowerCase().includes("exists")) {
      return i18n.t("errors.userAlreadyExists", "User with this email already exists.");
    }
  }

  if (!status) {
    return i18n.t("errors.unexpectedError", "An unexpected error occurred. Please try again later.");
  }

  if (status === 400 && detail) {
    return typeof detail === "string" ? detail : JSON.stringify(detail);
  }

  switch (status) {
    case 409:
      return i18n.t("errors.userAlreadyExists", "User with this email already exists.");
    case 500:
      return i18n.t("errors.serverError", "Server error. Please try again later.");
    default:
      return i18n.t("errors.genericError", "An error occurred. Please try again.");
  }
}
